export const TRANSLATE_KEYS_ES_ES = {
  //Login
  login_email: 'Correo electrónico',
  login_senha: 'Contraseña',
  entrar: 'Iniciar sesión',
  esqueci_minha_senha: 'Contraseña olvidada',

  //Recuperar Senha
  recuperar_senha_email: 'Correo electrónico',
  recuperar_senha: 'Recuperar contraseña',
  voltar_login: 'Atrás para iniciar sesión',
  recuperar_senha_mensagem_aviso: 'No se preocupe, introduzca su dirección de correo electrónico y le enviaremos un enlace para recuperar su acceso.',

  // Cadastro de senhas
  gerenciar_senhas_criar_senha: 'Contraseña de registro',
  gerenciar_senhas_titulo: 'Crear contraseña',

  // Placeholders
  placeholder_email: 'Ingrese su correo electrónico aquí',
  placeholder_senha: 'Ingrese su contraseña aquí',
  placeholder_documento: 'Ingrese su documento aquí',
  placeholder_celular: 'Ingrese su número de teléfono aquí',
  placeholder_empresa: 'Ingrese el nombre de su empresa aquí',
  placeholder_selecione: 'Selecione',
  placeholder_cargo: "Introduzca aquí su función",
  placeholder_nome_empresa: "Introduzca aquí el nombre de la empresa",
  placeholder_cnpj_empresa: "Introduzca aquí el CNPJ de la empresa",

  // Perfil
  perfil_cadastre_foto: 'Registre su foto',
  perfil_dados_pessoais: 'Datos personales',
  perfil_confira_seus_dados: 'Compruebe sus datos registrados y actualícelos si es necesario.',
  perfil_alterar_dados: 'Modificar datos',
  perfil_email: 'Correo electrónico',
  perfil_senha: 'Contraseña',
  perfil_confirmar_senha: 'Confirmar contraseña',
  perfil_direitos_autorais_rodape: 'Derechos de autor ©2000 - 2025.',
  perfil_todos_direitos_reservados_rodape: 'Todos los derechos reservados.',
  perfil_isencao_responsabilidade_conteudo_rodape: 'Todo el contenido del sitio, incluyendo todas las fotos, imágenes, conjuntos de imágenes, diseños, trade dress, mostrados aquí son puramente ilustrativos y son propiedad exclusiva de Grupo Imply o sus socios.',
  perfil_isencao_responsabilidade_reproducao_rodape: 'Se prohíbe la reproducción, total o parcial, de cualquier elemento de identidad sin autorización expresa.',
  perfil_isencao_responsabilidade_violacao_rodape: 'La violación de cualquier derecho mencionado implicará responsabilidad civil y penal conforme a los términos de la ley.',
  perfil_informacoes_imply_rodape: 'Imply Rental Equip. y Serv. | CNPJ: 14.928.256/0001-78 | Carretera de la Tecnología Imply, 1.111',
  perfil_requisito_letra_minuscula: 'Letra minúscula',
  perfil_requisito_letra_maiuscula: 'Letra mayúscula',
  perfil_requisito_incluir_numeros: 'Incluir números',
  perfil_requisito_caracter_especial: 'Carácter especial',
  perfil_requisito_mais_de_8_digitos: 'Más de 8 dígitos',
  perfil_requisito_confirmar_senha_igual: 'Contraseñas iguales',
  perfil_requisito_sem_espacos: 'La contraseña no debe contener espacios',
  perfil_salvar_atualizacao: 'Guardar actualización',
  perfil_cancelar_alteracao: 'Cancelar cambio',
  perfil_boas_vindas: 'Hola',
  perfil_alterar_senha: 'Modificar Contraseña',
  perfil_sucesso_alterar_senha: 'Contraseña cambiada con éxito!',
  perfil_nivel_permissao: 'Nivel de permiso',
  instituicao_ensino: 'Institución educativa.',

  //Eventos
  eventos_ativos: 'Eventos activos',
  eventos_inativos: 'Eventos inactivos',

  //Detalhes do evento
  incluir_colaboradores: 'Incluir colaboradores',
  status_negado: 'Negado',
  status_pendente: 'Pendiente',
  status_removido: 'Eliminado',
  status_aprovado: 'Aprobado',
  nenhum_colaborador_evento: 'No hay colaboradores al evento',
  incluir_veiculos: 'Incluir vehículos',
  nenhum_veiculo_evento: 'No hay vehículos en el evento',
  colaboradores: 'Colaboradores',
  nenhum_colaborador_disponivel: 'No hay colaboradores disponibles',
  veiculos: 'Vehículos',
  nenhum_veiculo_disponivel: 'No hay vehículos disponibles',
  aguardando_aprovacao_do_gestor_do_evento: 'Esperando la aprobación del gerente del evento',
  gestor_negou_a_devida_solicitacao: 'El gerente denegó la solicitud de acceso al empleado / vehículo apropiado',
  este_colaborador_foi_removida_a_autorizacao_pelo_permissionario: 'Solicitud de permiso eliminada',
  remove_solicitacao_de_autorizacao_do_acesso: 'Elimina la solicitud de acceso y bloquea el acceso si se aprobó previamente',
  baixa_arquivo_de_autorizacao: 'Descargue el archivo para imprimir',
  envia_um_email_com_anexo_para_o_colaborador: 'Envíe el archivo para imprimir directamente al correo electrónico informado en el momento del registro del empleado',
  informacoes: 'Información',
  solicitar_novamente_autorizacao: 'Solicitar aprobación de acceso',
  deseja_remover_a_solicitacao_do_evento_para_o_colaborador: '¿Desea eliminar la solicitud de acceso? (Si se autorizó previamente, se bloqueará el acceso)',
  deseja_enviar_email_para_o_colaborador_selecionado: '¿Desea enviar un correo electrónico al empleado seleccionado?',
  acesso_enviao_para_o_email_colaborador: 'e-mail enviado con éxito',
  caso_o_email_existir_sera_enviado_email: 'Si el correo electrónico ingresado es correcto, ¿se enviará un correo electrónico con la nueva contraseña, confirme el envío de la nueva contraseña?',
  acesso_enviado_pelo_email: 'Acceso enviado al correo electrónico del colaborador',

  // Colaboradores
  colaborador: 'Colaborador',
  colaborador_ver_todos: 'Ver todos los colaboradores',
  colaborador_incluir_novo: 'Incluir nuevos colaboradores',

  //Listagem de colaboradores
  buscar_colaborador: 'Buscar colaborador',
  buscar_permissionario: 'Buscar por permissionário',
  cadastrar: 'Registrar',
  atencao: 'Atención',
  deseja_excluir_colaborador: '¿Quieres eliminar al colaborador ',
  deseja_excluir: '¿Quieres eliminar ',
  cancelar: 'Cancelar',
  confirmar: 'Confirmar',
  colaborador_placeholder_nome_colaborador: 'Ingrese aquí el nombre del colaborador',
  colaborador_placeholder_email_colaborador: 'Introduzca aquí el correo electrónico del colaborador',
  colaborador_importar_lista: 'Importar lista de colaboradores',
  colaborador_importar_lista_suporte_csv: 'Soporte solo para archivos CSV',
  colaborador_total_cadastros: 'Total de personas registradas',
  colaborador_com_onboarding: 'Con onboarding',
  colaborador_sem_onboarding: 'Sin onboarding',
  buscar_empresa: 'Buscar empresas',
  onboarding: 'Onboarding',
  possui_onboarding: '¿Tiene incorporación?',

  //Cadastro de colaboradores
  cadastrar_colaborador: 'Registrar colaborador',
  editar_colaborador: 'Editar colaborador',
  documento: 'Documento',
  nome: 'Nombre',
  cadastro_email: 'Correo electrónico',
  telefone: 'Celular',
  sucesso: 'Éxito',
  colaborador_cadastrado_sucesso: '¡Colaborador registrado con éxito!',
  colaborador_editado_sucesso: '¡Colaborador editado con éxito!',
  finalizar: 'Terminar',
  ocorreu_erro_cadastro: 'No ha sido posible finalizar la inscripción en este momento. Por favor, inténtelo de nuevo.',
  ok: 'Ok',
  colaborador_nome_limitado_150_characteres: 'Nombre: máximo 150 caracteres alcanzados',
  colaborador_email_limitado_100_characteres: 'Correo electrónico: máximo 100 caracteres alcanzados',
  colaborador_informe_nome_completo: 'Ingrese el nombre completo',
  informe_um_celular_valido: 'Ingrese un número válido',
  informe_um_documento_valido: 'Por favor proporcione un documento válido',
  informe_um_email_valido: 'Ingrese un correo electrónico válido',
  editar: 'Editar',
  informe_todos_os_campos: 'Informar a todos los campos!',
  colaborador_ponto_focal: 'Ponto focal',
  colaborador_deletado_sucesso: '¡Colaborador eliminado con éxito!',

  //Visitantes
  visitante_visita_singular: 'Visita',
  visitante_inicio_visita: 'Inicio de visita',
  visitante_fim_visita: 'Fin de visita',
  visitante_agendar_visita: 'Programar otra visita',
  visitante_remover_visita: 'Eliminar visita añadida',
  visitante_informacao_inputs: 'Ingrese el nombre y el correo electrónico del visitante que desea invitar.',
  visitante_importar_lista: 'Importar lista de visitantes',
  visitante_importar_lista_suporte_csv: 'Soporte solo para archivos CSV',
  visitante_botao_enviar: 'Enviar invitación(es)',
  visitante_placeholder_nome_visitante: 'Ingrese aquí el nombre del visitante',
  visitante_placeholder_email_visitante: 'Introduzca aquí el correo electrónico del visitante',
  visitante_data_invalida: 'La fecha/hora de inicio no puede ser mayor que la fecha de fin.',
  visitante_inclusao_data_inicio: 'Fecha de inicio de la inclusión',
  visitante_inclusao_data_fim: 'Fecha final de inclusión',
  visitante_mostrar_filtros: 'Más filtros',
  visitante_ocultar_filtros: 'Ocultar filtros',
  visitante_periodo_visita: 'Estado del período de visita',
  buscar_visitante: "Buscar visitante",
  visitante_agenda_visitas: 'Visitas',
  visitante_deletar: "Eliminar visitante",
  visitante_visita_atualizada: "¡Visita actualizada con éxito!",
  visitante_incluir_novo: "Incluir nuevos visitantes",
  deseja_excluir_visitante: 'Desea excluir al visitante ',
  visitante_ver_todos: 'Ver todos los visitantes',

  //Alunos
  buscar_aluno: 'Buscar estudiante',
  aluno_incluir_novo: 'Incluir a nuevos estudiantes',
  aluno_informacao_inputs: 'Introduzca el nombre y la dirección de correo electrónico del estudiante al que desea invitar.',
  aluno_placeholder_email_aluno: 'Introduzca aquí la dirección de correo electrónico del estudiante',
  aluno_placeholder_nome_aluno: 'Introduzca aquí el nombre del estudiante',
  aluno_importar_lista: 'Importar lista de estudiantes',
  aluno_ver_todos: 'Ver todos los estudiantes',
  deseja_excluir_aluno: 'Desea excluir al estudiante ',
  visitante_preencha_campos: "Rellene las fechas anteriores para continuar",
  corrija_erro_data_para_prosseguir: "Corrija los conflictos de fechas para continuar",
  conflito_datas: 'Hay un conflicto entre las fechas, corríjalos para continuar',

  //Listagem de veículos
  buscar_veiculo: 'Buscar vehículo',
  deseja_excluir_veiculo: '¿Quieres eliminar el vehículo ',

  //Cadastro de veículos
  cadastrar_veiculo: 'Registrar vehículo',
  veiculo_marca_modelo: 'Marca / Modelo',
  veiculo_cor: 'Color',
  veiculo_placa: 'Placa',
  veiculo_status: 'Estado',
  ativo: 'Activo',
  inativo: 'Inactivo',
  veiculo_tipo: 'Tipo',
  veiculo_automovel: 'Automóvil',
  veiculo_motocicleta: 'Motocicleta',
  veiculo_caminhao: 'Camión',
  veiculo_cadastrado_sucesso: 'Vehículo registrado con éxito!',
  veiculo_editado_sucesso: 'Vehículo editado con éxito!',
  veiculo_placa_minimo_4_maximo_50: 'Ingrese una placa válida, mínimo: 4 Máximo: 50',
  veiculo_cor_50_characteres: 'Ingrese un color válido, Máximo: 50',
  veiculo_marca_modelo_minimo_4_maximo_50: 'Ingrese una marca / modelo válido, mínimo: 4 Máximo: 50',

  // Sucesso
  sucesso_convite_enviado: 'Invitación enviada exitosamente',
  sucesso_tudo_pronto: 'Todo listo!',
  sucesso_voltar: 'Volver',
  sucesso_voltar_login: 'Volver al inicio de sesión',
  sucesso_mensagem_verificar_spam: 'Caso no encuentres ningún correo electrónico en tu bandeja de entrada, verifica también la lista de correo no deseado',
  sucesso_pronto_acesso_caldeira: 'Está preparado para acceder a Caldeira con su cara',

  //Onboard
  onboard_label_selecione_genero: 'Seleccione su género',
  onboard_label_selecione_tipo_documento: 'Seleccione el tipo de su documento',
  onboard_label_documento: 'Documento',
  onboard_label_celular: 'Teléfono móvil',
  onboard_label_empresa: 'Su empresa',
  onboard_label_data_nascimento: 'Fecha de nacimiento',
  onboard_label_cargo: 'Función',
  onboard_button_pronto: 'Estoy listo',
  onboard_convidado_email: 'Usted ha sido invitado con el correo electrónico',
  onboard_instituicao: 'por la institución',
  onboard_confirme_dados_reconhecimento_facial: 'Confirme sus datos y realice el reconocimiento facial para acceder al Instituto Caldeira.',
  onboard_confirme_dados_recepcao: 'Confirme sus datos para acceder al Instituto Caldeira.',
  onboard_informaciones_enviadas: 'Información enviada con éxito',
  onboard_centralize_rosto: 'Centre su rostro en el espacio',
  onboard_rosto_capturado: 'Rostro capturado',
  onboard_capturar_imagen: 'Capturar imagen',
  onboard_capturar_novamente: 'Capturar de nuevo',
  onboard_enviar: 'Enviar',
  onboard_voltar: 'Volver',
  onboard_foto_titulo: 'Tome una foto',
  onboard_erro_camera: 'No fue posible acceder a la cámara. Verifique los permisos del navegador e intente nuevamente.',
  onboard_erro_enviar_foto: 'Error al enviar la foto. Intente nuevamente.',

  // Gêneros
  genero_nao_especificar: 'No especificar',
  genero_masculino: 'Masculino',
  genero_feminino: 'Femenino',
  genero_outros: 'Otro',

  //Informe de acessos
  informe_acessos: 'Informe de acceso',
  evento: 'Evento',
  todos: 'Todos',
  buscar: 'Buscar',
  selecione_um_evento: 'Selecciona un evento',
  selecione_um_colaborador_veiculo: 'Seleccione un colaborador / vehículo',

  nao_colaboradores: '¡Colaboradores no encontrados!',
  nao_veiculos: '¡Vehículos no encontrados!',
  nao_busca: 'Nada encontrado!',

  ac_restrito: 'Acceso restringido',
  pg_moveis: 'Página destinada a dispositivos móviles.',

  apr_img: '¡Tu imagen fue para aprobación!',
  msn_img: 'Si la imagen no es adecuada, rechace y envíe una nueva invitación al usuario',
  recusar: 'declive',
  aceitar: 'Aceptar',
  prosseguir: 'Continuar',
  capturar: 'Capturar',

  dicas_1: 'No tomes fotos borrosas o sombreadas.',
  dicas_2: 'No te tomes fotos con personas a tu lado o con accesorios que cubran tu rostro.',
  dicas_3: 'Utiliza esta imagen como referencia, una imagen con buena iluminación es ideal para que sea legible.',
  dicas_4: '¡Usa nuestra plantilla para posicionar tu rostro y deja tu imagen en el patrón de envío correcto!',

  qrcode: 'Qrcode',
  smartcard: 'SmartCard',
  facial: 'Facial',
  foto_pend: 'Foto pend.',
  pg_invalido: '¡LA PÁGINA NO EXISTE!',
  vincular_facial: 'Enlace a facial',

  whats_msn1: 'Hola, ',
  whats_msn2: '. Haga clic en el enlace para registrar su imagen en el sistema de acreditación de ',
  whats_msn3: '. El enlace es válido durante 24 horas. Recuerde registrarse antes de esta fecha límite, de lo contrario la acreditación será invalidada. Este es un mensaje automático, por favor no responda. Enlace',

  dicas: 'Sugerencias',
  credenciamento: 'Acreditación',
  cod_acesso: 'CÓDIGOS DE ACCESO',
  search_codigos: 'Códigos de búsqueda',
  nenhum_codigo_encontrado: 'No se encontró código o ya está vinculado!',
  descricao: 'Descripción',
  codigo: 'Código',

  error1: 'Token caducado. ¡Pídale nuevamente a su gerente la dirección de esta página!',
  error2: 'Persona no registrada',
  error3: 'Ya ha registrado la imagen, ¡espere la aprobación!',
  error4: 'No hay entradas',
  error5: 'Sin descripción',
  cpf_valida_obrigatoriedade: '*El CPF es obligatorio',
  cpf_valida_numero_digitos: '*El CPF debe tener 11 números',
  cpf_invalido: '*CPF inválido',
  cnpj_invalido: '*CNPJ inválido',
  campo_obrigatorio: '*Campo Obligatorio',
  data_invalida: "Fecha incorrecta",
  data_nascimento_invalida: "Por favor, ingrese una fecha de nacimiento válida.",

  error6: 'Descripción demasiado corta',

  _perfil: 'Perfil',
  _eventos: 'Eventos',
  _colaboradores: 'Colaboradores',
  _visitantes: 'Visitantes',
  _alunos: 'Estudiantes',
  _veiculos: 'Vehículos',
  _codigo: 'Códigos de acceso',
  _informe: 'Informe de acceso',
  _sair: 'Salir',
  _portaria: 'Recepción',
  _empresa: 'Empresas',

  gerar: 'Generar cód.',

  imply_nome_maiusculo: 'IMPLY',
  imply_nome_titlecase: 'Imply',

  concluir: 'Concluir',

  informe_nome_valido: 'Introduzca un nombre válido',
  informe_email_valido: 'Introduzca una dirección de correo electrónico válida',
  informe_documento_valido: 'El documento introducido no coincide con el documento registrado',

  assinar_newsletter: 'Suscribirse al boletín de Caldeira',
  assinar_newsletter_outsider: 'Deseo recibir newsletters, información sobre programas, inscripciones, eventos, iniciativas del Instituto Caldeira y comunicaciones relacionadas con socios y acciones del ecosistema.',
  concordo_com_termos: 'Estoy de acuerdo con los términos',
  sucesso_importacao_pessoa: 'Importación completada con éxito!',
  sem_informacao: 'No informado',
  empresa: 'Empresa',
  ou: 'ou',
  termo: 'Término LGPD',
  ver_mais: 'Ver más',
  ver_menos: 'Ver menos',
  gestor: 'Gestor',
  linha: 'Línea',
  info_modelo_csv_arquivos: 'Los archivos CSV deben estar separados por ";" o ",". clic',
  aqui: 'aquí',
  info_modelo_csv_baixar: 'para descargar una plantilla.',
  colaborador_campos_obrigatorios: 'Campos obligatorios: Nombre, Correo electrónico.',
  visitante_campos_obrigatorios: ' Campos obligatorios: Nombre, Correo electrónico, Fecha de inicio de la visita (01/01/2000 00:00), Fecha de fin de la visita (31/01/2000 23:59).',
  aluno_campos_obrigatorios: ' Campos obligatorios: Nombre, Correo electrónico, Fecha de inicio de la visita (01/01/2000), Fecha de fin de la visita (31/01/2000).',

  pessoa_incluir_novo: "Incluir persona",
  buscar_pessoas: "Buscar persona por nombre o correo electrónico",

  visitante: 'Visitante',
  aluno: 'Estudiante',
  pessoa_email: "Correo electrónico",
  pessoa_nome: "Nombre",
  visita_duracao: "Duración",
  visita_motivo: "Motivos",
  visita_dthr_inicio: "Inicio",
  visita_dthr_fim: "Fin",
  visita_complemento: "Complemento",
  portaria_qrcode_visita: "Código QR",
  send_email: "Enviar correo",
  voltar: "Volver",
  add_visita: "Añadir visita",
  ver_qrcode: "Ver Código QR visita",
  visitas_total_encontradas: "	Total de visitas encontradas",
  visita_incluir_novo: "Incluir nueva visita con QRcode",

  enviar_email_onboarding: "Enviar correo de incorporación",
  deletar_colaborador: "Eliminar empleado",
  deletar_aluno: "Eliminar estudiante",
  editar_aluno: "Editar estudiante",
  alterar_senha: "Haga clic aquí para cambiar su contraseña",
  permissionario: 'Permissionário',
  email_enviado: "Email enviado",

  notifications: 'Notificaciones',
  _news: 'Noticias',
  versao: 'Versión',
  app: 'APP',
  ver_news: 'Ver nuevo',
  add_empresa: "Nueva empresa",
  complete_onboarding: 'Incorporación completa',
  agenda_visitas: 'Visitas de visitantes / Estudiantes',
  deletar_selecionados: "Eliminar seleccionado(s)",
  confirmacao_exclusao: "¿Está seguro de que desea proceder con la exclusión?",
  pesquisar: "Buscar en",
  limpar_filtros: "Borrar filtros",
  visita_deletada_sucesso: "¡Visita(s) eliminada(s) con éxito!",
  sim: "Sí",
  nao: "No",
  passaporte: "Pasaporte",
  acoes: "Acciones",
  salvar: "Guardar",
  pessoas: "personas",
  sem_registro: "Sin registro",
  nome_empresa: "Nombre de la empresa",
  empresa_ver_todas: 'Ver todas las empresas',
  sucesso_cadastro_empresa: 'Empresa registrada con éxito',
  sucesso_editar_empresa: 'Empresa editada con éxito',
  sucesso_ativar_empresa: '¡Empresa activada con éxito!',
  sucesso_inativar_empresa: '¡Empresa desactivada con éxito!',
  ativar: 'Activar',
  inativar: 'Desactivar',
  deseja_ativar_empresa: '¿Desea activar la empresa',
  deseja_inativar_empresa: '¿Desea desactivar la empresa',
  buscar_cnpj: 'Búsqueda de empresas por CNPJ',
  empresas_total_encontradas: 'Total de empresas registradas',
  empresa_incluir_nova: 'Incluir nueva empresa',
  imprimir: "Imprimir",
  baixar: "Descargar",
  enviar_email_recuperacao_senha: "Enviar correo electrónico para registrar la contraseña",
  sucesso_envio_recuperacao_senha: "El enlace para restablecer la contraseña se ha enviado correctamente",
  sucesso_impressao: 'Impreso con éxito!',
  erro_impressao: 'Algo inesperado ocurrió durante el proceso de impresión.',
  imprimindo: 'Impresión...',

  merge_msg_1: "Se ha identificado la existencia de un registro en este documento utilizando la dirección de correo electrónico: ",
  merge_msg_2: "¿Desea fusionar los registros?",
  merge_msg_3: "Si confirma, el nombre y el correo electrónico de este registro se añadirán al registro existente!",

  remove_foto: "Foto eliminada con éxito",
  visualizar_foto: "Ver foto",
  delete_photo: "Eliminar foto",
  ver_foto: "Ver foto",
  statusFacial: "Estado facial",
  ultimaAtualizacao: "Última actualización",

  status: "Estado",
  status_realizado: "Realizado",
  sem_registros: "No hay registros",
  sincronizacao: "Sincronización",
  categoria: "Categoria",
  label_confirmar_email: "Confirme su dirección de correo electrónico para continuar",
  confirmar_email: "Confirmar correo",
  email_diferente: "La dirección de correo electrónico introducida no se corresponde con la registrada",
  portaria_importar_lista: 'Importar lista de personales',
  portaria_campos_obrigatorios: ' Campos obligatorios: Inicio, Fin.',
  portaria_motivo_obrigatorio: 'Rellene el motivo de su visita para continuar',
  portaria_tipo_documento: 'Tipo de documento',

  no_data: "Sin datos",
  qrcode_complete_onboarding: "Lea este código QR y complete su incorporación",
  qrcode_complete_onboarding_recepcao: "Use este QR Code para acceder al Caldeira",
  qrcode_onboarding: "QR Code onboarding",
  loading: "Cargando...",
  sucesso_cadastro_visita: "¡Registro realizado con éxito!",
  sucesso_cadastro_visita_msg: "Se envió un enlace de incorporación al correo electrónico del visitante.",
  enviar_qrcode_visita_email: "Enviar QRCode de la visita por correo electrónico",
};
